export default __webpack_public_path__ + "static/media/e2.108a71dd.jpg";